import React from "react";
import { useTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

export default function Footer() {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderTop: "1px solid #ffffff",
        fontFamily: "Arapey",
        textTransform: "uppercase",
        letterSpacing: ".05em",
        backgroundColor: "rgba(237,231,228,1)",
      }}
    >
      <p>© 2024 CK Wang Photography | VAT number: NL002515479B77</p>
      <p style={{ paddingLeft: "20px", width: "100px" }}>
        <a href="https://www.facebook.com/ckphotolab/">
          <FacebookIcon style={{ color: "#3e3e3e", fontSize: 22 }} />
        </a>
        {/* <a href="https://www.instagram.com/ckwang25/">
          <InstagramIcon
            style={{
              color: "#3e3e3e",
              fontSize: 22,
              pl: { xs: 0, md: "12px" },
            }}
          />
        </a> */}
      </p>
    </Paper>
  );
}
